export const hasHTMLTags = (string: string): boolean => {
  const regex = /<[^>]*>/
  return regex.test(string)
}
